﻿interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[]
    readonly userChoice: Promise<{
        outcome: "accepted" | "dismissed"
        platform: string
    }>

    prompt(): Promise<void>
}
export interface PwaInstallPrompt {
    onPromptReady: (callback: () => void) => void
    prompt: () => Promise<boolean>
}

export const createPwaInstallPrompt = (): PwaInstallPrompt => {
    let promptEvent: BeforeInstallPromptEvent | null = null
    const callbacks: (() => void)[] = []

    const notifyCallbacks = (): void => {
        if (promptEvent == null) {
            return
        }
        callbacks.forEach((callback) => callback())
    }

    window.addEventListener("beforeinstallprompt", (e: Event) => {
        e.preventDefault()
        promptEvent = e as BeforeInstallPromptEvent
        notifyCallbacks()
    })

    return {
        onPromptReady: (callback: () => void): void => {
            if (promptEvent) {
                callback()
            }
            callbacks.push(callback)
        },
        prompt: async (): Promise<boolean> => {
            if (!promptEvent) {
                throw new Error("No install prompt available")
            }
            await promptEvent.prompt()
            const choice = await promptEvent.userChoice
            return choice.outcome == "accepted"
        },
    }
}
